<template>
  <div class="wrapper">
    <div class="img-wrapper">
      <img class="product-img" :src="thumbnail" alt="product" />
      <img class="tag" v-if="tag" src="@/assets/images/tag-example.svg" alt="tag" />
      <div v-if="status === 'new'" class="new">NEW</div>
      <div v-else-if="status === 'hot'" class="hot">HOT</div>
    </div>
    <p class="title">{{ title }}</p>
    <div v-if="!isLaser && hasDiscount" class="discount-row">
      <span class="instant-discount">{{ t('instantDiscount') }}</span>
      <span class="original-price">฿{{ originalPrice }}</span>
      <span class="discount-percent">-{{ discountPercent }}%</span>
    </div>
    <div class="price-and-sold" v-if="!isLaser">
      <p class="price">฿{{ price }}</p>
      <p class="sold">{{ t('soldAmount', [ sold ])}}</p>
    </div>
    <span v-if="!isLaser && hasDiscount" class="no-coupon-needed">{{ t('noCouponNeeded') }}</span>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
export default {
  props: {
    title: {
      type: String,
      require: true,
    },
    price: {
      type: String,
      require: true,
    },
    sold: {
      type: [ Number, String ],
      require: true,
    },
    tag: {
      type: String,
    },
    status: {
      type: String,
      require: true,
    },
    thumbnail: {
      type: String,
      default: ''
    },
    isLaser: {
      type: Boolean,
       default: false,
    },
    // Discount decorations. Omitted by callers that do not surface discounts,
    // in which case the card renders exactly as before.
    originalPrice: {
      type: String,
      default: '',
    },
    discountPercent: {
      type: [ Number, String ],
      default: 0,
    },
    discountActive: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    /** context */
    const { t } = useI18n()

    const hasDiscount = computed(() => (
      props.discountActive && Number(props.discountPercent) > 0 && !!props.originalPrice
    ))

    return {
      t,
      hasDiscount,
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  transition: 0.1s;
  cursor: pointer;
  &:active {
    opacity: 0.8;
  }
}

.img-wrapper {
  position: relative;
  background-color: var(--white-color);
}

.product-img {
  width: 100%;
  min-height: 136px;
  max-height: 180px;
  border-radius: 6px;
  object-fit: contain;
}

/* FIX TASK 2: Clamp title to exactly 2 lines so the price row
   always starts at the same vertical position across all cards
   in a grid row, regardless of title length.
   - line-height: 1.4 + font-size 14px → each line is 19.6px
   - min-height: 39.2px holds space even for 1-line titles
   - -webkit-line-clamp: 2 truncates titles longer than 2 lines
   No layout, SEO, or behaviour changes beyond visual alignment. */
.title {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.4;
  min-height: calc(14px * 1.4 * 2); /* = 39.2px — always 2 lines tall */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.price-and-sold {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
}

.price {
  font-size: 14px;
  font-weight: bold;
  color: #FD6868;
}

.sold {
  font-size: 12px;
  color: #6A6A6A;
}

.discount-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  padding-top: 4px;
}

.instant-discount {
  font-size: 10px;
  font-weight: bold;
  color: #FFFFFF;
  background-color: #FD6868;
  border-radius: 3px;
  padding: 1px 5px;
  white-space: nowrap;
}

.original-price {
  font-size: 12px;
  color: #9A9A9A;
  text-decoration: line-through;
}

.discount-percent {
  font-size: 10px;
  font-weight: bold;
  color: #FD6868;
  border: 1px solid #FD6868;
  border-radius: 3px;
  padding: 1px 4px;
  white-space: nowrap;
}

.no-coupon-needed {
  display: inline-block;
  font-size: 10px;
  color: #6A6A6A;
  border: 1px solid #D8D8D8;
  border-radius: 3px;
  padding: 1px 5px;
  white-space: nowrap;
}

.tag {
  position: absolute;
  top: 0;
  right: 5%;
}

.new {
  background-color: #ffe209;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 10px;
  position: absolute;
  top: 2%;
  left: 2%;
}

.hot {
  background-color: #fa4040;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 10px;
  position: absolute;
  top: 2%;
  left: 2%;
  color: var(--white-color);
}
</style>
